import { render, staticRenderFns } from "./ArticleTableOfContents.vue?vue&type=template&id=3c00c15f&scoped=true"
import script from "./ArticleTableOfContents.vue?vue&type=script&lang=js"
export * from "./ArticleTableOfContents.vue?vue&type=script&lang=js"
import style0 from "./ArticleTableOfContents.vue?vue&type=style&index=0&id=3c00c15f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c00c15f",
  null
  
)

export default component.exports